<div *ngIf=" machinePermissionsATP === true || machinePermissionsPASS === true || machinePermissionsMAX === true">
  <app-inventory-views [deviceType]="deviceType"></app-inventory-views>
</div>